// Wait for the DOM to load
document.addEventListener("DOMContentLoaded", () => {
    const regions = document.querySelectorAll(".people-block__region");
    const profiles = document.querySelectorAll(".people-block__result");

    if (regions) {
        regions.forEach((region) => {
            // Add event listener to each region
            region.addEventListener("click", (e) => {
                // Add the 'active' class to the clicked region
                e.target.classList.add("active");

                // Remove the 'active' class from all other regions
                regions.forEach((region) => {
                    if(region !== e.target) {
                        region.classList.remove("active");
                    }
                });

                // Get the name of the region that was clicked, which is inside a p tag in the clicked div
                let regionName = e.target.dataset.region;
                
                console.log(e.target.firstChild);
                console.log(regionName);

                // If the region name is "Show All", show all profiles
                if(regionName === "all") {
                    profiles.forEach((profile) => {
                        profile.classList.remove("hidden");
                    });
                    return;
                }

                // Hide the profiles that do not contain the region name in the data-region attribute
                profiles.forEach((profile) => {
                    if(profile.dataset.region !== regionName) {
                        profile.classList.add("hidden");
                    } else {
                        profile.classList.remove("hidden");
                    }
                }
                );        

            });
        });
    }
});